import { useTranslation } from "react-i18next";
import { Clock, MapPin, Smartphone } from "lucide-react";

// آخر دخول/جهاز/موقع لعضو فريق المنصة.
export const StaffMeta = ({ member }) => {
  const { t } = useTranslation();
  const when = member.last_seen_at ? new Date(member.last_seen_at).toLocaleString("en-GB") : null;
  const place = [member.last_city, member.last_country].filter(Boolean).join(", ");
  if (!when && !member.last_device && !place) {
    return (
      <p className="mt-2 text-[11px] text-muted-foreground" data-testid={`staff-meta-${member.email}`}>
        {t("staff.noLogin")}
      </p>
    );
  }
  const items = [
    [Clock, when || "—"],
    [Smartphone, member.last_device || "—"],
    [MapPin, place || member.last_ip || "—"],
  ];
  return (
    <div
      className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-muted-foreground"
      data-testid={`staff-meta-${member.email}`}
    >
      {items.map(([Icon, value], index) => (
        <span key={index} className="flex items-center gap-1.5">
          <Icon className="h-3 w-3" />
          <span dir="ltr" className="font-mono">{value}</span>
        </span>
      ))}
    </div>
  );
};
